import { render, staticRenderFns } from "./AccountManagement.vue?vue&type=template&id=707cff22&scoped=true&"
import script from "./AccountManagement.vue?vue&type=script&lang=js&"
export * from "./AccountManagement.vue?vue&type=script&lang=js&"
import style0 from "./AccountManagement.vue?vue&type=style&index=0&id=707cff22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707cff22",
  null
  
)

export default component.exports